export const productPackagesFormComponents: Array<string> = [
  'packageName', 'packageType', 'size', 'location', 'articles', 'palletType', 'comment'
]
